import { useEffect, useState } from "react";
import { api, apiErr } from "../lib/api";
import { toast } from "sonner";
import { Landmark, ShieldCheck } from "lucide-react";

const inp = "border border-input bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-black";

export function PostWageAccountPanel() {
  const [acct, setAcct] = useState(null);
  const [edit, setEdit] = useState(false);
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({ account_holder: "PostWage", institution: "", transit: "", account_number: "" });
  const load = () => api.get("/payments/postwage-account").then((r) => setAcct(r.data.account)).catch((e) => toast.error(apiErr(e)));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = await api.put("/payments/postwage-account", { ...form, account_type: "Checking" });
      setAcct(data.account); setEdit(false); toast.success(`PostWage account tokenized (····${data.account.last4}).`);
    } catch (e2) { toast.error(apiErr(e2)); } finally { setBusy(false); }
  };
  const remove = async () => {
    if (!window.confirm("Remove the PostWage settlement account?")) return;
    try { await api.delete("/payments/postwage-account"); setAcct(null); toast.success("Removed"); } catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <div className="border border-border bg-white p-6 max-w-3xl" data-testid="postwage-account-panel">
      <h2 className="font-bold tracking-tight flex items-center gap-2"><Landmark className="h-4 w-4" /> PostWage settlement account</h2>
      <p className="text-xs text-muted-foreground mt-1">Where the difference lands under <b>Full payroll funding</b> (CRA PD7A, WSIB, EHT and third-party amounts PostWage remits on the client's behalf). Tokenized at Forte — only the last 4 digits are stored.</p>
      <div className="mt-4 text-sm flex flex-wrap items-center gap-3" data-testid="postwage-account-summary">
        {acct ? <span>{acct.account_holder} · ····{acct.last4}{acct.bank ? ` · ${acct.bank}` : ""} · set {String(acct.tokenized_at || "").slice(0, 10)}</span>
          : <span className="text-amber-700">Not set — held funds will be labelled "PostWage" without an account.</span>}
        <button data-testid="postwage-account-edit" onClick={() => setEdit((v) => !v)} className="text-xs border border-black px-3 py-1.5 hover:bg-black hover:text-white transition-colors">{acct ? "Replace" : "Set account"}</button>
        {acct && <button data-testid="postwage-account-remove" onClick={remove} className="text-xs underline underline-offset-2 text-muted-foreground hover:text-black">Remove</button>}
      </div>
      {edit && (
        <form onSubmit={save} className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 border border-border bg-neutral-50/60 p-3 mt-4" data-testid="postwage-account-form">
          <input data-testid="pw-holder" required placeholder="Account holder" value={form.account_holder} onChange={(e) => setForm({ ...form, account_holder: e.target.value })} className={inp} />
          <input data-testid="pw-institution" required placeholder="Institution (3 digits)" value={form.institution} onChange={(e) => setForm({ ...form, institution: e.target.value })} className={inp} />
          <input data-testid="pw-transit" required placeholder="Transit (5 digits)" value={form.transit} onChange={(e) => setForm({ ...form, transit: e.target.value })} className={inp} />
          <input data-testid="pw-account" required placeholder="Account number" type="password" autoComplete="off" value={form.account_number} onChange={(e) => setForm({ ...form, account_number: e.target.value })} className={inp} />
          <div className="sm:col-span-2 lg:col-span-4 flex items-center justify-between gap-3">
            <span className="text-[11px] text-muted-foreground flex items-center gap-1"><ShieldCheck className="h-3.5 w-3.5" /> Sent once to Forte over TLS and replaced by a token.</span>
            <button data-testid="pw-account-save" disabled={busy} className="bg-black text-white px-4 py-2 text-sm hover:bg-neutral-800 disabled:opacity-50">{busy ? "Tokenizing…" : "Save & tokenize"}</button>
          </div>
        </form>
      )}
    </div>
  );
}
